import { render, staticRenderFns } from "./main.devolucionesProveedor.vue?vue&type=template&id=11478b5b"
import script from "./main.devolucionesProveedor.vue?vue&type=script&lang=js"
export * from "./main.devolucionesProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports